document.addEventListener("DOMContentLoaded", function(){
    // SCROLLING CONTENT WITH STATIONARY IMAGES
    const observerOptions = {
        root: null,
        rootMargin: "0px",
        threshold: 0.25
    };
      
    function observerCallback(entries, observer) {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                // fade in observed elements that are in view
                entry.target.classList.replace('fadeOut', 'fadeIn');
                const contentIndex = entry.target.dataset.scrolling_content;
                const entryParent = entry.target.closest('.vertical-scrolling-wrapper')
                const entryImg = entryParent.querySelector(`.sticky-image-${contentIndex}`);
                if (entryImg) {
                    entryImg.classList.replace('fadeOut', 'fadeIn');
                }
                console.log('fade in')
            } else {
                // fade out observed elements that are not in view
                entry.target.classList.replace('fadeIn', 'fadeOut');
                console.log('fade out')
                const contentIndex = entry.target.dataset.scrolling_content;
                const entryParent = entry.target.closest('.vertical-scrolling-wrapper')
                const entryImg = entryParent.querySelector(`.sticky-image-${contentIndex}`);
                if (entryImg) {
                    entryImg.classList.replace('fadeIn', 'fadeOut');
                }
            }
        });
    }
    
    const observer = new IntersectionObserver(observerCallback, observerOptions);
    
    const fadeElms = document.querySelectorAll('.fade');
    if ( fadeElms.length > 0 ) {
        fadeElms.forEach(el => observer.observe(el));
    }
})